if (window.__cardSizeAddRegistered) {
  // already registered by a previous instance of this script
} else {
  window.__cardSizeAddRegistered = true;

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('.card__sizes-toggle');
  function closeAllDrawers() {
    document.querySelectorAll('.card-wrapper.sizes-open').forEach(function (w) {
      w.classList.remove('sizes-open');
      const t = w.querySelector('.card__sizes-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.card__sizes.is-drawer').forEach(function (sizes) {
      sizes.classList.remove('is-drawer-open');
      const original = sizes._originalParent;
      setTimeout(function () {
        sizes.classList.remove('is-drawer');
        if (original) original.appendChild(sizes);
        sizes._originalParent = null;
      }, 280);
    });
    document.body.classList.remove('sizes-drawer-open');
  }

  if (toggle) {
    event.preventDefault();
    event.stopPropagation();
    const wrapper = toggle.closest('.card-wrapper');
    if (!wrapper) return;

    const willOpen = !wrapper.classList.contains('sizes-open');
    closeAllDrawers();

    if (willOpen) {
      const sizes = wrapper.querySelector('.card__sizes');
      if (sizes) {
        wrapper.classList.add('sizes-open');
        toggle.setAttribute('aria-expanded', 'true');
        sizes._originalParent = wrapper.querySelector('.card__information') || wrapper;
        document.body.appendChild(sizes);
        sizes.classList.add('is-drawer');
        sizes.offsetHeight; // force reflow for transition
        sizes.classList.add('is-drawer-open');
        document.body.classList.add('sizes-drawer-open');
      }
    }
    return;
  }

  if (!event.target.closest('.card__sizes') && !event.target.closest('.card__sizes-toggle')) {
    closeAllDrawers();
  }
});

document.addEventListener('click', function (event) {
  const button = event.target.closest('.card__size-button');
  if (!button || button.disabled || button.classList.contains('loading')) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  document.querySelectorAll('.card-wrapper.sizes-open').forEach(function (w) {
    w.classList.remove('sizes-open');
    const t = w.querySelector('.card__sizes-toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
  });
  document.querySelectorAll('.card__sizes.is-drawer').forEach(function (sizes) {
    sizes.classList.remove('is-drawer-open');
    const original = sizes._originalParent;
    setTimeout(function () {
      sizes.classList.remove('is-drawer');
      if (original) original.appendChild(sizes);
      sizes._originalParent = null;
    }, 280);
  });
  document.body.classList.remove('sizes-drawer-open');

  const cart =
    document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  button.classList.add('loading');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        console.error('Cart add error:', response);
        return;
      }
      if (cart) {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      } else {
        window.location = window.routes.cart_url;
      }
    })
    .catch((error) => {
      console.error('Cart add fetch failed:', error);
    })
    .finally(() => {
      button.classList.remove('loading');
    });
});

}
